import { render, staticRenderFns } from "./ProductStocks.vue?vue&type=template&id=79704298&scoped=true&"
import script from "./ProductStocks.vue?vue&type=script&lang=js&"
export * from "./ProductStocks.vue?vue&type=script&lang=js&"
import style0 from "./ProductStocks.vue?vue&type=style&index=0&id=79704298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79704298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VSelect})
